import { api } from "../../api";
import {
  ActivitiesResponse,
  ActivityItem,
  ActivityItemsResponse,
  CreateOriginFields,
  ShippingCaseResponse,
} from "./types";

export async function getShippingCaseApi(
  id: number,
): Promise<ShippingCaseResponse> {
  const { data } = await api.get<ShippingCaseResponse>(
    `/api/shipping-cases/${id}`,
  );
  return data;
}

export async function getActivitiesApi(
  offer_id: number,
): Promise<ActivitiesResponse> {
  const { data } = await api.get<ActivitiesResponse>(
    `/api/activities/grouped`,
    {
      params: { offer_id },
    },
  );
  return data;
}

export async function getActivitiesByRouteApi(
  id: number,
  route: string,
): Promise<ActivityItemsResponse> {
  const { data } = await api.get<ActivityItemsResponse>(
    `/api/shipping-cases/${id}/activities`,
    {
      params: { activity__route__in: route },
    },
  );
  return data;
}

export async function updateOriginApi(
  params: CreateOriginFields,
  shipping_id: number,
  id: number,
): Promise<ActivityItem> {
  const { data } = await api.patch<ActivityItem>(
    `/api/shipping-cases/${shipping_id}/activities/${id}`,
    {
      ...params,
    },
  );
  return data;
}

export async function completeActivityApi(
  sid: number,
  ativityId: number,
  params: { completion_date: string; execution_date: string },
): Promise<ActivityItem> {
  const { data } = await api.patch<ActivityItem>(
    `/api/shipping-cases/${sid}/activities/${ativityId}`,
    {
      ...params,
    },
  );
  return data;
}
